import { makeAutoObservable, runInAction } from "mobx";
import i18n from "i18next";
import MainStore from "MainStore";
import { getOrganizations } from "api/Organisation/index";
import { deleteOrganization } from "api/Organisation/index";

class NewStore {
  data = [];
  mainData = [];
  openPanel = false;
  currentId = 0;
  searchField = "";

  constructor() {
    makeAutoObservable(this);
  }

  onEditClicked(id: number) {
    runInAction(() => {
      this.openPanel = true;
      this.currentId = id;
    });
  }
  changeSearch = (value: string) => {
    this.searchField = value
  }

  onSearchClicked = () => {
    const data = this.mainData.filter(x => 
      x?.organization_code?.toLowerCase().includes(this.searchField?.toLowerCase())
      || x?.name?.toLowerCase().includes(this.searchField?.toLowerCase())
      || x?.short_name?.toLowerCase().includes(this.searchField?.toLowerCase())
      || x?.inn?.toLowerCase().includes(this.searchField?.toLowerCase())
      || x?.email?.toLowerCase().includes(this.searchField?.toLowerCase())
    )
    this.data = data;
  }

  clearSearch() {
    this.searchField = "";
    this.loadOrganizations()
  }

  closePanel() {
    runInAction(() => {
      this.openPanel = false;
      this.currentId = 0;
    });
  }

  loadOrganizations = async () => {
    try {
      MainStore.changeLoader(true);
      const response = await getOrganizations();
      if ((response.status === 201 || response.status === 200) && response?.data !== null) {
        this.data = response.data;
        this.mainData = response.data;
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  };

  deleteOrganization = (id: number) => {
    MainStore.openErrorConfirm(
      i18n.t("areYouSure"),
      i18n.t("delete"),
      i18n.t("no"),
      async () => {
        try {
          MainStore.changeLoader(true);
          const response = await deleteOrganization(id);
          if (response.status === 201 || response.status === 200) {
            this.loadOrganizations();
            MainStore.setSnackbar(i18n.t("message:snackbar.successDelete"));
          } else {
            throw new Error();
          }
        } catch (err) {
          MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
        } finally {
          MainStore.changeLoader(false);
          MainStore.onCloseConfirm();
        }
      },
      () => MainStore.onCloseConfirm()
    );
  };

  clearStore = () => {
    runInAction(() => {
      this.data = [];
      this.currentId = 0;
      this.openPanel = false;
      this.searchField = "";
    });
  };
}

export default new NewStore();